import { Pipe, PipeTransform } from '@angular/core';
import { MoneyFormat } from 'src/app/shared/utils/format';

@Pipe({ name: 'money' })
export class MoneyPipe implements PipeTransform {
    transform(value: number, args?: any): string {
        return MoneyFormat(value, args);
    }
}
